/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useMutation } from '@apollo/client' // Npm: Apollo client.


/*
 * PACKAGES
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import CustomerAccountDeleteMutation from './__mutation__/index.customerAccount.delete.mutation'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose }) => {
  // Hook assignment.
  const [MutationCustomerAccountDelete, MutationCustomerAccountDeleteResponse] = useMutation(CustomerAccountDeleteMutation)

  // Return Component.
  return (
    <DeleteCard onClose={onClose} onConfirm={() =>
      MutationCustomerAccountDelete({
        'variables': {
          'customerAccountId': passOn?.customerAccountId
        }
      }).then(i => {
        // Style Guide.
        toast(i?.data?.CustomerAccountDelete?.message)

        // Report success.
        return onClose?.()
      }).catch(() =>
        // Style Guide.
        toast('Something went wrong please try after some time.'))} isLoading={MutationCustomerAccountDeleteResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
